import * as Sentry from '@sentry/react';
import { safeWindow } from '@sky-distribution/gp-onboarding-shared-utils';
import { SENTRY_DSN } from '../config';
import { getSessionId } from '../sessionId';

export interface MonitoringConfiguration extends Sentry.BrowserOptions {
  projectName: string;
  projectVersion: string;
}

export const initMonitoring = ({
  projectName,
  projectVersion,
  ...rest
}: MonitoringConfiguration): void => {
  const env = safeWindow().__env;

  if (!env?.DEPLOY_ENV_NAME) {
    return;
  }

  Sentry.init({
    dsn: SENTRY_DSN,
    integrations: [Sentry.browserTracingIntegration({
      tracePropagationTargets: [/^\//],
    })],
    release: `${projectName}@${projectVersion}`,
    normalizeDepth: 10,
    environment: env.DEPLOY_ENV_NAME,
    ...rest,
  });

  Sentry.setUser({
    id: getSessionId(),
  });
};
